<app-deprecated-modal #documentPreview>
    <app-pdf-viewer #pdfViewer></app-pdf-viewer>
</app-deprecated-modal>

<div class="ui basic segment" [class.loading]="isLoading">
    <app-employee-header [employee]="employee" (isLoading)="isLoading = $event"></app-employee-header>

    <div class="ui layout">
        <div class="sidebar">
            <app-profile-card [model]="employee"></app-profile-card>
        </div>

        <div class="content">
            <!-- Empty State -->
            <div class="ui segment" *ngIf="isPayrollSyncEnabled && !paginator.total">
                <app-empty-state
                    src="/assets/illustrations/documents.png"
                    label="{{ 'payroll.paystubs.notFound' | translate }}"
                ></app-empty-state>
            </div>

            <!-- Not on payroll -->
            <div class="ui segment" *ngIf="!isPayrollSyncEnabled">
                <app-empty-state
                    src="/assets/illustrations/documents.png"
                    label="{{ 'payroll.paystubs.notOnPayroll' | translate }}"
                ></app-empty-state>
            </div>

            <!-- Has Content -->
            <div class="ui table segment" *ngIf="paginator && paginator.total">
                <app-segment-header
                    [paginator]="paginator"
                    title="{{ 'payroll.paystubs.title.employee' | translate }}"
                ></app-segment-header>
                <table class="ui table">
                    <thead>
                        <tr>
                            <th>{{ 'payroll.paystubs.dateSent' | translate }}</th>
                            <th></th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let paystub of paginator.values">
                            <td>{{ paystub?.chequeDate | appDate }}</td>
                            <td>
                                <ui-button
                                    type="link"
                                    (click)="
                                        addPendoTrackingForViewPaystub();
                                        pdfViewer.setSource(getUrl(paystub));
                                        documentPreview.show()
                                    "
                                    >{{ 'payroll.paystubs.view' | translate }}</ui-button
                                >
                            </td>
                            <td>
                                <ui-button
                                    type="link"
                                    (click)="addPendoTrackingForDownloadPaystub(); onDownload(paystub)"
                                    >{{ 'payroll.paystubs.download' | translate }}</ui-button
                                >
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
